import { render, staticRenderFns } from "./PrivacyNL.vue?vue&type=template&id=59ef54a2&"
import script from "./PrivacyNL.vue?vue&type=script&lang=js&"
export * from "./PrivacyNL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports